export default {
  c_home: "Home",
  c_homeAdmin: "Home",
  c_create: "Add New",
  c_list: "List",
  c_update: "Update",
  c_delete: "Delete",
  c_deletes: "Delete",
  c_detail: "Detail",
  c_duplicate: "Duplicate",
  c_view: "view",
  c_close: "Close",
  c_search: "Search",
  c_filter: "Filter",
  c_back: "Back",
  c_success: "Success",
  c_error: "Unsuccesful",
  c_record: "Record",
  c_fromDate: "From Day",
  c_toDate: "To Day",
  c_order: "Sort",
  c_drag: "Drag and Drop",
  c_select: "Select",
  c_agree: "Agree",
  c_cancel: "Cancel",
  c_sendTcqltt: "Send to DMS",
  c_showHideSearch: "Hide/Show search",
  c_toggle: "Collapse/Expand",
  c_action: "Action",
  c_total: "Total",
  c_toPage: "To page",
  c_enter: "Enter",
  c_yes: "Yes",
  c_no: "No",
  c_selectLeader: "Tour leader",
  c_changeStatus: "Change status",
  c_showCheckin: "Check in",
  c_showQrcode: "Qr code",
  c_showTaiapp: "Download app",
  c_exportExcel: "Export excel",
  c_addSuccess: "Add new success",
  c_addError: "More new failed",
  c_addduplicateError: "More new failed",
  c_updateSuccess: "Successful update",
  c_updateError: "Update failed",
  c_deleteSuccess: "Successful deleted",
  c_deleteError: "Deletion failed",
  c_uploadError: "Upload failed",
  c_recordSuccess: "Successful record",
  c_recordError: "Record failed",
  c_deleteConfirm: "Are you sure to delete this record?",
  c_notAllowAccess: "No access to this page",
  c_emptyRecord: "You have not selected any record",
  c_loginAgain: "You need to login first,Please!",
  c_findError: "Error occurred",
  c_uploadConfirm: "Are you sure to upload file?",
  c_selectLeaderConfirm:
    "Are you sure you want to select this traveler as team leader?",
  c_unselectLeaderConfirm:
    "Are you sure you want to unselect this team leader?",
  c_addCodeSuccess: "Register MS code success",
  valid: "Allow",
  valid_required: "Missing value",
  valid_email: "Email is invalid",
  valid_link: "The link is not properly formatted",
  valid_imageLink: "Image Link is not properly formatted",
  valid_sign: "Do not enter accented characters",
  valid_space: "Do not enter white characters",
  valid_script: "do not enter special characters",
  valid_az09: "Only enter a to z and 0 to 9",
  valid_az09Dot: "Only enter a to z , A to Z and the dots",
  valid_account: "Only accepted: a-z, 0-9, dot (.) and @",
  valid_textFirst: "The first character must be text",
  valid_floatNegative: "Do not enter number negative",
  valid_dateTime: "The data and time are incorrect",
  valid_date: "The Day is incorrect",
  valid_year: "The Year is incorrect",
  valid_month: "The month is incorrect",
  valid_number: "Only enter numbers from 0 to 9",
  valid_integer: "Enter integers only ",
  valid_float: "Only enter whole numbers or decimal numbers",
  valid_tuNgay: "The date must be less than or equal to the date",
  valid_denNgay: "The date must be greater than or equal to the date",
  valid_upload: "Please selete the file",
  valid_file: "file",
  valid_character: "character(s)",
  valid_max: "Do not the bigger",
  valid_min: "Not smaller",
  valid_length: "The input value must be",
  valid_requiredUpload: "Please , select",
  valid_password: "Minimum six characters",
  valid_insert: "Insert",
  valid_insertMinimum: "Insert minimum",
  valid_to: "to",
  valid_insertThan: "Need to input at least",
  valid_insertLess: "Need to input no more than",
  valid_compareTime: "Begin time must be less than finish time",
  valid_compareStartEndTime: "Time range mush be inside the time range of tour",
  valid_compareTimeThongBao: "Creation time must be less than expired time",
  login: "Login",
  login_error: "Username or password is incorrect",
  login_account: "Username/Email",
  login_password: "Password",
  login_remember: "Remember Login",
  logout: "Logout",
  logout_all: "Do you logout of other devices?",
  logout_success: "Logout successful",
  logout_error: "Logout failed",
  c_changePasswordSuccess: "Change password success",
  c_changePasswordError: "Change password failed",
  c_changePasswordErrorOld: "Old password wrong",
  c_changePasswordErrorReEnterNew: "Re-enter password not match",
  c_changePasswordErrorOldNew:
    "The new password must not match the old password",
  c_resetPassword: "Reset password",
  c_resetPasswordSuccess: "Reset password success",
  c_resetPasswordError: "Reset password failed",
  header_gotoUserProfile: "User profile",
  header_goClient: "To page users",
  header_goChangePassword: "Change password",
  p404_error: "The path is not correct",
  p404_backPage: "Pervious page",
  nav_qlnguoidung: "User management",
  nav_dsnguoidung: "User list",
  default_container_footer_header: "CONTACT INFORMATION & SUPPORT:",
  default_container_footer_phone_number: "Phone number",
  User: "User",
  user: "User",
  user_disableConfirm: "Are you sure this user is locked?",
  user_undisableConfirm: "Are you sure this user is locked?",
  user_disableSuccess: "Lock user sucessful",
  user_disableError: "Lock user failed",
  user_undisableSuccess: "Lock user sucessful",
  user_undisableError: "Lock user failed",
  user_nameAccount: "Name account",
  user_roles: "Roles",
  user_lock: "lock",
  user_unlock: "Unlock",
  user_locked: "Locked",
  user_hidden: "Hidden",
  user_unhide: "Show",
  user_pinned: "Pinned",
  user_unpin: "Unpin",
  user_reEnterPass: "Re-enter the password",
  user_password: "Enter Password",
  user_newPassword: "Enter new password",
  user_oldPassword: "Enter old password",
  user_whitePassword: "Password (Leave blank to keep the password)",
  user_position: "Positon",
  user_nameUser: "Name user",
  user_phoneNumber: "Phone number",
  user_profile: "User profile",
  user_profile_avatar: "Avatar",
  user_profile_fullname: "Fullname",
  user_profile_phone_number: "Phone number",
  user_profile_email: "Email",
  user_profile_gender: "Gender",
  user_profile_gender_male: "Male",
  user_profile_gender_female: "Female",
  user_profile_gender_NA: "N/A",
  user_profile_gender_other: "Other",
  daily_safety_data: "Daily safety data",
  tour_operators: "Tour operators",
  tour_list: "Tour list",
  tour_ticket: "Tour ticket",
  accommodation_facility: "Accommodation facility",
  tour_guide: "Tour guide",
  tourists: "Tourists",
  reflect: "Reflect",
  news: "News",
  high_quality_travel_service: "High quality travel service",
  evaluate: "Evaluate",
  notification: "Notification",
  daily_alert: "Daily alert",
  program: "Program",
  program_register: "Program register",
  achievements_badge: "Achievements badge",
  safe_destination: "Safe destination",
  daily_safety_assessment: "Daily safety assessment",
  checkIn_safe_destination: "Check-in safe destination",
  epidemic_area: "Epidemic area",
  traveler_reviews: "Traveler reviews",
  safe_destination_rating: "Safe destination rating",
  issuing_tourist_card_code: "Issuing tourist card code",
  Ads: "Advertisement",
  category: "Category",
  review_team: "Review team",
  reflection_group: "Reflection group",
  news_category: "News Category",
  foreign_language: "Foreign language",
  nationality: "Nationality",
  forte: "Forte",
  armorial: "Armorial",
  configuration: "Configuration",
  user_of_category: "Users",
  user_of_GDOMM: "Users of the General Department of Market Management",
  version: "Version",
  to_title: "tour operators",
  to_key: "Key",
  to_company_name: "Company name",
  to_email: "Email",
  to_phone: "Phone",
  to_website: "Website",
  to_address: "Address",
  to_evaluate: "Evaluate",
  to_action: "Action",
  to_avatar: "Avatar",
  to_vietnamese_name: "Vietnamese name",
  to_english_name: "English name",
  to_hotline: "Hotline",
  to_list_of_Managers: "List of Managers",
  to_manager: "Manager",
  to_fullname: "Full name",
  to_gender: "Gender",
  to_business_license_number: "Business license number",
  to_place_of_business_license: "Place of business license",
  to_slogan: "Slogan",
  af_title: "accommodation facility",
  af_name: "Accommodation facility name",
  af_address: "Address",
  af_type: "Type",
  af_ratings: "Ratings",
  af_total_number_of_rooms: "Total number of rooms",
  af_action: "Action",
  af_vietnam: " (Viet Nam)",
  af_english: " (English)",
  af_province: "Province",
  af_district: "District",
  af_commune: "Commune",
  af_phone: "Phone",
  af_area_code: "Area code",
  af_landline_phone: "Landline phone",
  af_fax: "Fax",
  af_logo: "Logo",
  af_email: "Email",
  af_website: "Website",
  af_service: "Service",
  af_decision_number: "Decision number",
  af_decision_date: "Decision date",
  af_lowest_price: "Lowest price",
  af_highest_price: "Highest price",
  tg_title: "tour guide",
  tg_fullname: "Fullname",
  tg_card_number: "Card number",
  tg_gender: "Gender",
  tg_bod: "Date of birth",
  tg_email: "Email",
  tg_phone: "Phone",
  tg_evaluate: "evaluate",
  tg_avatar: "Avatar",
  tg_nationality: "Nationality",
  tg_address: "Address",
  tg_card: "Tour guide card",
  tg_card_status: "Card status",
  tg_card_type: "Card type",
  tg_issued_by: "Issued by",
  tg_date_range: "Date range",
  tg_expiration_date: "Expiration date",
  tg_papers: "Papers",
  tg_add_papers: "Add papers",
  tg_number_of_papers: "Number of papers",
  tg_more_information: "More information",
  tg_foreign_language: "Foreign language",
  tg_forte: "Forte",
  tg_achievements: "Achievements",
  tg_number_of_guided_tours: "Number of guided tours",
  tg_practice_history: "Practice history",
  tg_number_of_years_of_practice: "Number of years of practice",
  tgl_title: "tour guide led",
  tgl_fullname: "Fullname",
  tgl_card_number: "Card number",
  tgl_number_of_tour_led: "Number of tour led",
  tgl_tour_guide: "Tour guide",
  tgl_gender: "Gender",
  tgl_bod: "Date of birth",
  tgl_email: "Email",
  tgl_phone: "Phone",
  tgl_evaluate: "evaluate",
  tgl_avatar: "Avatar",
  tgl_nationality: "Nationality",
  tgl_card: "Tour guide card",
  tgl_card_type: "Card type",
  tgl_card_status: "Card status",
  tgl_issued_by: "Issued by",
  tgl_date_range: "Date range",
  tgl_expiration_date: "Expiration date",
  tgl_papers: "Papers",
  tgl_add_papers: "Add papers",
  tgl_papers_type: "Papers type",
  tgl_number_of_papers: "Number of papers",
  tgl_address: "Address",
  tgl_more_information: "More information",
  tgl_foreign_language: "Foreign language",
  tgl_forte: "Forte",
  tgl_achievements: "Achievements",
  tgl_number_of_guided_tours: "Number of guided tours",
  tgl_practice_history: "Practice history",
  tgl_number_of_years_of_practice: "Number of years of practice",
  trs_title: "tourists",
  trs_fullname: "Fullname",
  trs_card_number: "Card number",
  trs_gender: "Gender",
  trs_bod: "Date of birth",
  trs_email: "Email",
  trs_phone: "Phone",
  trs_address: "Address",
  trs_avatar: "Avatar",
  trs_nationality: "Nationality",
  trs_number_of_papers: "Number of papers",
  trs_type_of_papers: "Type of papers",
  trs_issued_by: "Issued by",
  trs_date_range: "Date range",
  trs_expiration_date: "Expiration date",
  rf_title: "reflect",
  rf_choose: "Choose",
  rf_sender: "Sender",
  rf_sender_reflects: "The sender reflects",
  rf_reflection_group: "Reflection group",
  rf_reflection_group_type: "Reflection group",
  rf_content: "Content",
  rf_time: "Time",
  rf_status: "Status",
  rf_reflection_day: "Reflection day",
  rf_person_in_charge: "Person in charge",
  rf_phone_number: "Phone number",
  rf_reflect_to: "Reflect to",
  rf_subjects_receiving_feedback: "Subjects receiving feedback",
  rf_name_of_object_receiving_feedback: "Name of object receiving feedback",
  rf_reflection_time: "Reflection time",
  rf_attached_files: "Attached files",
  rf_location_on_the_map: "Location on the map",
  rf_from: "From",
  rf_to: "to",
  rf_cause: "Cause",
  rf_transfer_history_reflects: "Transfer history reflects",
  ns_title: "news",
  ns_title_label: "Title",
  ns_place: "Place",
  ns_date_created: "Date created",
  ns_date_submitted: "Date Submitted",
  ns_articles_status: "Articles status",
  ns_language: "Language",
  ns_news_category: "News category",
  ns_display_object: "Display object",
  ns_hide: "Hide",
  ns_category: "Category",
  ns_created_time: "Created time",
  ns_posting_time: "Posting time",
  ns_timer: "Timer",
  ns_content: "Content",
  ns_news_image: "News image",
  ns_avatar: "Avatar",
  ns_province: "Province",
  ns_location_on_the_map: "Location on the map",
  hqts_title: "high quality travel service",
  hqts_hide: "Hide",
  hqts_service_hide: "Service hide",
  hqts_services_name: "Services name",
  hqts_evaluate: "Evaluate",
  hqts_pin: "Pin",
  hqts_service_pins: "Service pins",
  hqts_pin_status: "Pin status",
  hqts_approved: "Approved",
  hqts_date_created: "Date created",
  hqts_vietnam: " (Viet Nam)",
  hqts_english: " (English)",
  hqts_order: "Order",
  hqts_browse_status: "Browse status",
  hqts_not_approved: "Not approved",
  hqts_unapproved_reason: "Unapproved reason",
  hqts_content: "Content",
  hqts_place: "Place",
  hqts_province: "Province",
  hqts_district: "District",
  hqts_commune: "Commune",
  hqts_address: "Address",
  hqts_location_on_the_map: "Location on the map",
  hqts_service_image: "Service image",
  hqts_avatar: "Avatar",
  hqts_post_photo: "Post photo",
  ev_title: "evaluate",
  ev_assessor: "Assessor",
  ev_object_type: "Object type",
  ev_assessment_object: "Assessment object",
  ev_evaluate: "Evaluate",
  ev_created_time: "Created time",
  ev_evaluation_object_type: "Evaluation object type",
  ev_enter_tour_name: "Enter tour name",
  ev_enter_tour_guide_name: "Enter tour guide name",
  ev_enter_travel_service_name: "Enter travel service name",
  ev_enter_safe_destination_name: "Enter a safe destination name",
  ev_enter_accommodation_name: "Enter accommodation name",
  ev_enter_tourists_name: "Enter the tourists name",
  ev_detailed_ingredient_evaluation: "Detailed ingredient evaluation",
  ev_ingredient_evaluation_team: "Ingredient Evaluation Team",
  ev_value: "Value",
  ev_content: "Content",
  ev_violation_criteria: "Violation criteria",
  ntfs_title: "notifications",
  ntfs_link_label: "Link",
  ntfs_send_by: "Send by",
  ntfs_notifications_type: "Notifications type",
  ntfs_title_label: "Title",
  ntfs_notifications_content: "Notifications content",
  ntfs_created_time: "Created time",
  ntfs_expiration_time: "Expiration time",
  ntfs_start_time: "From date",
  ntfs_end_time: "To date",
  ntfs_tour: "Tour",
  ntfs_enter_keywords_to_search: "Enter keywords to search",
  ntfs_receiver_tourists: "Receiver (tourists)",
  ntfs_receiver_tour_guide: "Receiver (tour guide)",
  ntfs_search_by_card_number: "Search by card number",
  ntfs_tourists_list: "Tourists list",
  ntfs_tour_guide_list: "Tour guide list",
  ntfs_fullname: "Fullname",
  ntfs_card_number: "Card number",
  ntfs_gender: "Gender",
  ntfs_bod: "Date of birth",
  ntfs_email: "Email",
  ntfs_phone: "Phone",
  ntfs_address: "Address",
  ntfs_avatar: "Avatar",
  ntfs_nationality: "Nationality",
  da_title: "daily alert",
  da_content: "Content",
  da_object: "Object",
  da_order: "Order",
  da_effective_date: "effective_date",
  da_expiration_date: "Expiration date",
  da_effect: "Effect",
  da_vietnam: " (Viet Nam)",
  da_english: " (English)",
  pr_title: "program",
  pr_code: "Program code",
  pr_name: "Program name",
  pr_content: "Content",
  pr_start_time: "Time to start",
  pr_end_time: "Time to end",
  pr_effect: "Effect",
  pr_vietnam: " (Viet Nam)",
  pr_english: " (English)",
  pr_add_subject_to_apply: "More subject to apply",
  pr_object_type: "Object type",
  pr_link_survey: "Link survey",
  prr_title: "program register",
  prr_program: "Program",
  prr_choose: "Choose",
  prr_object: "Object",
  prr_created_time: "Created time",
  prr_update_time: "Update time",
  prr_user: "User",
  prr_badge_level: "Badge level",
  ab_title: "badge level",
  ab_badge: "Badge",
  ab_badge_holder: "Badge holder",
  ab_badge_receipt: "Time of receipt",
  ab_enter_keywords_to_search: "Enter keywords to search",
  ab_created_time: "Created time",
  ab_note: "Note",
  sd_title: "safe destination",
  sd_safe_destination_name: "Safe destination name",
  sd_safe_destination_type: "Safe destination type",
  sd_tourist_incentives: "Discount",
  sd_tour_guide_incentives: "Discount",
  sd_account_code: "Account code",
  sd_unit_name: "Unit name",
  sd_tax_code: "Tax code",
  sd_address: "Address",
  sd_register_time: "Register time",
  sd_approved: "Approved",
  sd_status: "Status",
  sd_province: "Province",
  sd_district: "District",
  sd_enter_safe_destination_list: "Enter a safe destination list",
  sd_csotf: "THE CURRENT STATE OF THE FACILITY",
  sd_active: "Active",
  sd_unactive: "Unactive",
  sd_avatar: "Avatar",
  sd_papers: "Papers",
  sd_issued_by: "Issued by",
  sd_date_range: "Date range",
  sd_scanned_copy_of_business_registration:
    "Scanned copy of business registration",
  sd_image_papers_scan: "Image papers scan",
  sd_representative: "Representative",
  sd_representative_name: "Representative name",
  sd_position: "Position",
  sd_bod: "Date of birth",
  sd_gender: "Gender",
  sd_email: "Email",
  sd_phone: "Phone",
  sd_safety_criteria: "Safety criteria",
  csd_title: "check-in safe destination",
  csd_checkIn_time: "Check-in time",
  csd_created_object: "Created Object",
  csd_safe_destination: "Safe destination",
  csd_tourists: "Tourists",
  csd_avatar: "Avatar",
  csd_front: "Front",
  csd_backside: "Backside",
  csd_enter_keywords_to_search: "Enter keywords to search",
  csd_travel_card_code: "Travel card code",
  csd_last_7_days: "The last 7 days",
  csd_last_30_days: "The last 30 days",
  csd_check_scan_qr_code:
    "PLEASE SCAN THE QR CODE FOR COVID-19 SAFETY CHECK AND ASSESSMENT",
  csd_print_qr: "Print_qr",
  csd_download_qr: "Download QR",
  csd_fullname: "Fullname",
  csd_passport: "Passport",
  csd_qr_code: "QR Code",
  csd_visa_approved_time: "Visa approved time",
  csd_user_visa_approved: "User approved visa",
  csd_entry_time: "Time of entry",
  csd_user_approved: "User approved",
  csd_cancel: "Cancel",
  csd_approved: "Approved",
  csd_tourist_information: "Tourist information",
  csd_phone_number: "Phone number",
  csd_safety_criteria: "Safety criteria",
  csd_user_checkIn: "User check-in",
  csd_no_data: "No data",
  csd_user_created: "User created",
  eg_title: "evaluation component group",
  eg_order: "Order",
  eg_status: "Status",
  eg_object_evaluation: "Object evaluation",
  eg_vietnamese_name: "Vietnamese name",
  eg_english_name: "English name",
  eg_hide: "Hide",
  rg_title: "reflection group",
  rg_status: "Status",
  rg_object_reflection: "Object reflection",
  rg_order: "Order",
  rg_vietnamese_name: "Vietnamese name",
  rg_english_name: "English name",
  rg_move_TCQLTT: "Move TCQLTT",
  nc_title: "news category",
  nc_name: "Name",
  nc_highlights: "Highlights",
  nc_hide: "Hide",
  nc_order: "Order",
  nc_language: "Language",
  nc_avatar: "Avatar",
  nc_icon: "Icon",
  al_title: "armorial",
  al_code: "Armorial code",
  al_image: "Image",
  al_vietnamese_name: "Vietnamese name",
  al_english_name: "English name",
  al_effect: "Effect",
  al_status: "Status",
  user_title: "user",
  user_account_name: "Account name",
  user_name: "User name",
  user_right_to_use: "Right to use",
  user_avatar: "Avatar",
  user_phone_number: "Phone number",
  user_email: "Email",
  user_gender: "Gender",
  rsd_title: "safe destination",
  rsd_safe_destination_name: "Safe destination name",
  rsd_safe_destination_type: "Safe destination type",
  rsd_address: "Address",
  rsd_province: "Province",
  rsd_district: "District",
  rsd_commune: "Commune",
  rsd_csotf: "THE CURRENT STATE OF THE FACILITY",
  rsd_active: "Active",
  rsd_unactive: "Unactive",
  rsd_avatar: "Avatar",
  rsd_representative: "Representative",
  rsd_representative_name: "Representative name",
  rsd_position: "Position",
  rsd_bod: "Date of birth",
  rsd_gender: "Gender",
  rsd_email: "Email",
  rsd_website: "Website",
  rsd_phone: "Phone",
  rsd_safety_criteria: "Safety criteria",
  rsd_business_registration: "Business registration",
  rsd_update_unit_information: "Update unit information",
  rsd_number_of_papers: "Number of papers",
  ea_title: "epidemic area",
  ea_province: "Province",
  ea_status: "Epidemic status",
  ea_total_infections: "Total infections",
  ea_total_recovery: "Total recovery",
  ea_total_death: "Total death",
  ea_number_of_infections: "Number of infections",
  ea_number_of_recoveries: "Number of recoveries",
  ea_number_of_deaths: "Number of deaths",
  ea_address: "Specific address",
  ea_longitude: "Longitude",
  ea_latitude: "Latitude",
  ea_location_on_the_map: "Location on the map",
  ea_created_time: "Created time",
  tr_title: "tourists",
  tr_fullname: "Fullname",
  tr_card_number: "Card number",
  tr_gender: "Gender",
  tr_bod: "Date of birth",
  tr_email: "Email",
  tr_phone: "Phone",
  tr_address: "Address",
  tr_avatar: "Avatar",
  tr_nationality: "Nationality",
  tr_number_of_papers: "Number of papers",
  tr_type_of_papers: "Type of papers",
  tr_issued_by: "Issued by",
  tr_date_range: "Date range",
  tr_expiration_date: "Expiration date",
  tr_evaluate: "Evaluate",
  tr_number_of_evaluate: "Number of evaluate",
  trd_title: "traveler reviews",
  trd_evaluate: "Evaluate",
  trd_assessor: "Assessor",
  trd_assessment_object: "Assessment object",
  trd_created_time: "Created time",
  trd_checkIn_time: "Check-in time",
  trd_detailed_ingredient_evaluation: "Detailed ingredient evaluation",
  trd_ingredient_evaluation_team: "Ingredient Evaluation Team",
  trd_value: "Value",
  trd_content: "Content",
  trd_violation_criteria: "Violation criteria",
  sdr_title: "safe destination",
  sdr_safe_destination_name: "Safe destination name",
  sdr_safe_destination_type: "Safe destination type",
  sdr_register_code: "Register code",
  sdr_tax_code: "Tax code",
  sdr_address: "Address",
  sdr_province: "Province",
  sdr_district: "District",
  sdr_commune: "Commune",
  sdr_evaluate: "Evaluate",
  sdr_number_of_evaluate: "Number of evaluate",
  sdrd_title: "safe destination rating detail",
  sdrd_evaluate: "Evaluate",
  sdrd_assessor: "Assessor",
  sdrd_assessment_object: "Assessment object",
  sdrd_created_time: "Created time",
  sdrd_checkIn_time: "Check-in time",
  sdrd_detailed_ingredient_evaluation: "Detailed ingredient evaluation",
  sdrd_ingredient_evaluation_team: "Ingredient Evaluation Team",
  sdrd_value: "Value",
  sdrd_content: "Content",
  sdrd_violation_criteria: "Violation criteria",
  gdmm_title: "lower grade",
  gdmm_superior: "Superior",
  gdmm_user: "User",
  gdmm_subordinates: "subordinates",
  gdmm_current_user: "lower grade",
  tl_title: "tour",
  tl_name: "Tour name",
  tl_group_name: "Group name",
  tl_place: "Place",
  tl_number_of_guests: "The number of guests",
  tl_total_guests: "Total number of guests",
  tl_number_of_adults: "The number of adults",
  tl_child_5_to_15_year: "Number of children from 5 to 15 years old",
  tl_child_under_5_year: "Number of children under 5 years old",
  tl_start_time: "Time to start",
  tl_end_time: "Time to end",
  tl_evaluate: "Evaluate",
  tl_finish: "Finish",
  tl_status: "Status",
  tl_province: "Province",
  tl_location_on_the_map: "Location on the map",
  tl_journeys: "Journeys",
  tl_add_journeys: "Add journeys",
  tl_starting_place: "Starting place",
  tl_ending_place: "Ending place",
  tl_content: "Content",
  tl_car_information: "Car information",
  tl_license_plates: "License plates",
  tl_drivers_name: "Driver name",
  tl_driver_phone_number: "Driver phone number",
  tl_hotel_restaurent: "Hotel, restaurent",
  tl_add_hotel: "Add hotel",
  tl_add_restaurent: "Add restaurent",
  tl_hotel_name: "Hotel name",
  tl_restaurent_name: "Restaurent name",
  tl_manager_name: "Manager name",
  tl_phone: "Phone",
  tl_address: "Address",
  tl_image_of_tour: "Image of tour",
  tl_avatar: "Avatar",
  tl_image_tour: "Tour image",
  tl_tour_profile: "Tour profile",
  tl_tourists: "Tourists",
  tl_fullname: "Fullname",
  tl_card_number: "Card number",
  tl_gender: "Gender",
  tl_bod: "Date of birth",
  tl_bom: "Month of Birth",
  tl_boy: "Year of Birth",
  tl_email: "Email",
  tl_nationality: "Nationality",
  tl_confirmed_traveler_list: "List of confirmed travelers",
  tl_waiting_confirmed_traveler_list:
    "List of tourists waiting for confirmation",
  tl_tourists_without_card: "List of tourists without a tourist card",
  tl_tourists_in_excel_file: "List of tourists in excel file",
  tl_guest_identifier: "Guest identifier",
  tl_search_by_document_number: "Search by document number",
  tl_enter_keywords_to_search: "Enter keywords to search",
  tl_import_from_excel_file: "Import from excel file",
  tl_sample_excel_file: "Sample excel file",
  tl_tour_guide: "Tour guide",
  tl_confirmed_tour_guide_list: "List of confirmed tour guide",
  tl_guide_card_number: "Guide card number",
  tl_title_label: "Title",
  tl_venue_of_event: "Venue of the event",
  tl_one_place: "One place",
  tl_two_place: "Two place",
  tl_numerical_order: "No.",
  tl_ms_code: "MS code/Card number",
  tl_number_of_papers: "Number of papers",
  tl_type_of_papers: "Type of papers",
  tl_issued_by: "Issued by",
  tl_date_range: "Date range",
  tl_month_range: "Month range",
  tl_year_range: "Year range",
  tl_expiration_date: "Expiration date",
  tl_expiration_month: "Expiration month",
  tl_expiration_year: "Expiration year",
  tt_title: "tour ticket",
  tt_tour: "Tour",
  tt_tour_name: "Tour name",
  tt_tour_guide: "Tour guide",
  tt_start_time: "Time to start",
  tt_end_time: "Time to end",
  tt_enter_keywords_to_search: "Enter keywords to search",
  tt_fullname: "Fullname",
  tt_card_number: "Card number",
  tt_gender: "Gender",
  tt_bod: "Date of birth",
  tt_email: "Email",
  tt_phone: "Phone",
  tt_nationality: "Nationality",
  tt_confirmed_tour_guide_list: "List of confirmed tour guide",
  tt_waiting_confirmed_tour_guide_list:
    "List of tour guide waiting for confirmation",
  tt_guide_card_number: "Guide card number",
  tt_find_tour_guide_by_card_number: "Find tour guide by card number",
  tt_find_tour_guide_by_document_number: "Find tour guide by document number",
  tt_attached_files: "Attached files",
  itcc_title: "issuing tourist card code",
  itcc_surname_buffer: "Surname buffer",
  itcc_name: "Name",
  itcc_identity: "Identity card/Citizen identification/Passport",
  itcc_tourist_card_registration_code: "Tourist card registration code",
  itcc_card_number: "Card number",
  itcc_gender: "Gender",
  itcc_bod: "Date of birth",
  itcc_email: "Email",
  itcc_phone: "Phone",
  itcc_nationality: "Nationality",
  itcc_choose: "Choose",
  itcc_number_of_papers: "Number of papers",
  itcc_health_insurance_card_number: "Health insurance card number",
  itcc_passport_number: "Passport number",
  itcc_country_code: "Country code",
  itcc_guardians: "Guardians",
  ads_title: "Advertisement",
  ads_order: "Order",
  ads_visibleImage: "Pictures",
  ads_link: "Advertisement link",
  ads_screen: "Screen",
  ads_banner_name: "Banner name",
};
